// extracted by mini-css-extract-plugin
module.exports = {"upload":"upload--AiShl","uploadBox":"uploadBox--1W4D7","compareBox":"compareBox--1Y0MR","comparison":"comparison--3eyKd","startCompare":"startCompare--14ULm"};